/**
 * Created by zhangyanbo on 2017/2/21.
 */

/**
 * @file
 * @auth zhangyanbo
 * @date 2016/2/21
 */


import Vue from 'vue';
import tpl from './tpl.html';
import commonService from '../../../common/commonService';
import Loading from '../../../component/Loading.vue';
import Pager from '../../../component/Pager.vue';
import NoData from '../../../component/NoData.vue';
import ParseUrl from '../../../util/parseUrl';




export default Vue.extend({
    name: "blockInfo",
    template: tpl,
    components: {
        Loading,
        Pager,
        NoData
    },
    data(){
        return {
            isLoading:false,
            condition: {
                pageNo: 1,
                pageSize: 10
            },
            pageNum: 0,
            agentName:'',
            blockList:[],
        }
    },
    created() {
        this.getUrlParam();
    },
    mounted(){
        window.scrollTo(0,0);
    },
    methods: {
        /*
         * 获取地址栏中参数
         *
         * */
        getUrlParam(){
            let tempParam = ParseUrl();
            if(localStorage.agentPageNo) {
                this.condition.pageNo = localStorage.agentPageNo;
            }
            this.agentName = tempParam.blockAgent;
            this.fetchBlockList()

        },
        fetchBlockList(){
            this.isLoading = true;
            let param = {
                'signee':this.agentName,
                'page':+this.condition.pageNo,
                'per_page':this.condition.pageSize
            };
            commonService.blockInfo(param).done((rep) => {
                this.blockList = rep.result.data;
                this.pageNum = Math.ceil(rep.result.total/this.condition.pageSize);

            }).fail((rep) => {
                window.error("网络异常，请稍后再试");
            }).always(()=>{
                this.isLoading = false;

            });

        },
        searchAccount(param) {
            let that = this;
            setTimeout(function(){
                that.getUrlParam();
            },0)
        },

        /**
         * 分页
         * @param pageNo
         */
        changePage(pageNo) {
            localStorage.agentPageNo = +pageNo;

            this.condition.pageNo = pageNo;
            this.fetchBlockList();
        }




    }
});





// WEBPACK FOOTER //
// ./src/module/index/blockAgent/main.js